import {useMutation, useQueryClient} from "@tanstack/react-query";
import {deleteContactApi} from "../../../../api/correspondent/contractApi";
import useGoToNavigation from "../../../../util/useGotoNavigation";
import {useModal} from "../../../../hooks";

type Props = {
    clear?: () => void;
};

/**
 * 연락처 삭제
 * @param props
 * @returns
 */
const useDeleteContact = ({clear}: Props) => {
    const {goToNavigation} = useGoToNavigation();
    const queryClient = useQueryClient();
    const {handleModal, resetModal} = useModal();

    const {mutate} = useMutation({
        mutationFn: (data: { id: string }[]) => deleteContactApi(data),
        onSuccess: (res) => {
            if (res.code === "0000") {
                handleModal({
                    isOpen: true,
                    contents: "삭제되었습니다.",
                    type: "alert",
                    closeAction: () => {
                        goToNavigation("customer/contact/list", {}, true);
                        queryClient?.invalidateQueries({
                            queryKey: ["readContactList"],
                        });
                    }
                })
            } else {
                handleModal({
                    isOpen: true,
                    contents: res.msg,
                    type: "alert"
                })
            }
        },
        onError: (error) => {
            console.log(error);
        },
    });
    return {mutate};
};

export default useDeleteContact;
